<template>
  <div id="vue-dictionary-list">
    <div class="letter-filters">
      <div class="letters">
        <span v-for="letter in alphabet" v-on:click="filterChange(letter)" class="letter" :class="{ 'active' : letter == filter}">
          {{ letter }}
        </span>
      </div>
    </div>

    <div class="dictionary-results">
      <div class="dictionary-results-grid">
        <div v-for="result in results" class="dictionary-result">
          <p class="title">{{ result.title }}</p>
          <p class="desc">{{ result.desc }}</p>
          <div class="button-wrap">
            <a v-bind:href="result.url" class="button primary-flip">czytaj dalej</a>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'dictionary_vue_app',
  data () {
    return {
      alphabet: 'abcdefghijklmnoprstuwyz'.split(''),
      filter: 'a',
      results: []
    }
  },
  watch: {
    enabled (value) {
      const body = document.getElementsByTagName('body')
    }
  },
  methods: {
    reloadResults() {
      axios
        .get('/api/v1/dictionary/termsbyletter/' + this.filter, [])
        .then(response => {
          this.results = response.data.data.terms
      })
    },

    filterChange (newFilter) {
      if (this.filter != newFilter) {
        this.filter = newFilter
        this.reloadResults()
      }
    },
  },
  created () {
    this.reloadResults()
  }
}
</script>
